<template>
  <div class="bill-detail-page" :class="{ mobile: isMobileLayout }">
    <el-steps :active="3" align-center>
      <el-step title="选择影片场次"></el-step>
      <el-step title="选择座位"></el-step>
      <el-step :title="orderTimeoutMinutes + '分钟内付款'"></el-step>
      <el-step title="影院取票观影" status="wait"></el-step>
    </el-steps>
    <div class="bill-info-container">
      <!-- 订单状态 -->
      <!-- 未支付，未取消，2分钟内 -->
      <div class="bill-info-status" v-if="payState === false && cancelState === false && (minutes > 0 || seconds > 0)">
        <div class="pay-icon">
          <img src="../../assets/money.png">
        </div>
        <div class="pay-info">
          <div class="pay-info-status">待支付</div>
          <div class="pay-info-desc">请在<span>{{minutes}}分钟{{seconds}}秒</span>内完成支付</div>
        </div>
      </div>
      <!-- 未支付，超时取消，2分钟 -->
      <div class="bill-info-status invalid" v-if="payState === false && cancelState === true && cancelTime === null && minutes <= 0 && seconds <= 0">
        <div class="pay-icon">
          <img src="../../assets/bill-invalid.png">
        </div>
        <div class="pay-info">
          <div class="pay-info-status invalid">由于订单超时未支付，已失效</div>
        </div>
      </div>
      <div class="bill-info-status finish" v-if="payState === true && !refundState">
        <div class="pay-icon">
          <i class="iconfont icon-r-yes" style="color: #26CE61; font-size: 38px;"> </i>
        </div>
        <div class="pay-info">
          <div class="pay-info-status finish">已完成</div>
        </div>
      </div>
      <!-- 已退款状态 -->
      <div class="bill-info-status refund" v-if="refundState">
        <div class="pay-icon">
          <i class="iconfont icon-r-delete" style="color: #FF9800; font-size: 38px;"> </i>
        </div>
        <div class="pay-info">
          <div class="pay-info-status refund">已退款</div>
          <div class="pay-info-desc" v-if="billInfo.refundTime">退款时间: {{formatDateTime(billInfo.refundTime)}}</div>
        </div>
      </div>
      <div class="bill-info-status invalid" v-if="cancelState === true && cancelTime !== null">
        <div class="pay-icon">
          <i class="iconfont icon-r-delete" style="color: #f03d37; font-size: 38px;"> </i>
        </div>
        <div class="pay-info">
          <div class="pay-info-status invalid">{{ billInfo.payFailState ? '支付失败，订单已关闭' : '订单已取消' }}</div>
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="bill-info-desc">
        <div class="bill-info-header">
          <span>订单编号: {{billInfo.billId}}</span>
          <div class="bill-info-helper">
            <span>(有订单问题可拨打客服电话</span>
            <span class="bill-info-phone">{{billInfo.sysSession.sysHall.sysCinema.cinemaPhone}}</span>
            <span>，工作时间:</span>
            <span class="bill-info-hours">{{billInfo.sysSession.sysHall.sysCinema.workStartTime}}-{{billInfo.sysSession.sysHall.sysCinema.workEndTime}}</span>
            <span>)</span>
          </div>
        </div>

        <table v-if="!isMobileLayout" class="order-table">
          <thead>
          <tr>
            <th>影片</th>
            <th>语言版本</th>
            <th>播放时间</th>
            <th>座位</th>
            <th>提示信息</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="movie-name">《{{billInfo.sysSession.sysMovie.movieName}}》</td>
            <td class="movie-name">{{billInfo.sysSession.languageVersion}}</td>
            <td class="showtime">{{billInfo.sysSession.sessionDate}} {{billInfo.sysSession.playTime}} - {{billInfo.sysSession.endTime}}</td>
            <td>
              <span class="hall">{{billInfo.sysSession.sysHall.hallName}}</span>
              <div class="seats">
                <span class="bill-seat" v-for="item in billSeats" :key="item"> {{item}} </span>
              </div>
            </td>
            <td>
              <span>{{billInfo.sysSession.sessionTips}}</span>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-else class="mobile-order-card">
          <div class="mobile-order-row">
            <span class="mobile-order-label">影片</span>
            <span>《{{billInfo.sysSession.sysMovie.movieName}}》</span>
          </div>
          <div class="mobile-order-row">
            <span class="mobile-order-label">语言版本</span>
            <span>{{billInfo.sysSession.languageVersion}}</span>
          </div>
          <div class="mobile-order-row">
            <span class="mobile-order-label">播放时间</span>
            <span>{{billInfo.sysSession.sessionDate}} {{billInfo.sysSession.playTime}} - {{billInfo.sysSession.endTime}}</span>
          </div>
          <div class="mobile-order-row">
            <span class="mobile-order-label">座位</span>
            <span>{{billInfo.sysSession.sysHall.hallName}} · {{billSeats.join(' / ')}}</span>
          </div>
          <div class="mobile-order-row">
            <span class="mobile-order-label">提示信息</span>
            <span>{{billInfo.sysSession.sessionTips || '无'}}</span>
          </div>
        </div>
      </div>
      <!-- 影院信息、提交订单 -->
      <div class="bill-info-area">
        <div class="cinema-info">
          <span class="bill-cinema-name">{{billInfo.sysSession.sysHall.sysCinema.cinemaName}}</span>
          <div class="bill-cinema-info">
            <span>地址: {{billInfo.sysSession.sysHall.sysCinema.cinemaAddress}} </span>
            <span>电话: {{billInfo.sysSession.sysHall.sysCinema.cinemaPhone}} </span>
          </div>
        </div>
        <div class="submit-bill">
          <div>总价：<span>{{(billInfo.sysSession.sessionPrice * billSeats.length).toFixed(1)}}</span></div>

          <!-- 已支付，显示退款按钮 -->
          <div v-if="payState === true && !refundState" style="margin-top: 20px;">
            <el-button @click="showRefundDialog" type="warning" style="font-size: 20px;" round>
              <i class="iconfont icon-r-left" style="font-size: 20px;"></i>
               申请退款
            </el-button>
          </div>

          <!-- 支付方式选择 -->
          <div v-if="payState === false && cancelState === false && (minutes > 0 || seconds > 0)" style="margin-top: 20px;">
            <div style="margin-bottom: 15px; font-size: 16px; color: #333;">请选择支付方式：</div>
            <el-radio-group v-model="paymentChannel" class="payment-channel-group">
              <el-radio label="MOCK_WECHAT" class="payment-channel-item">
                <span style="font-size: 16px;">模拟微信支付</span>
                <div style="font-size: 12px; color: #999; margin-top: 2px;">测试支付，可选择支付结果</div>
              </el-radio>
              <el-radio label="MOCK_ALIPAY" class="payment-channel-item">
                <span style="font-size: 16px;">模拟支付宝支付</span>
                <div style="font-size: 12px; color: #999; margin-top: 2px;">测试支付，可选择支付结果</div>
              </el-radio>
              <el-radio label="ALIPAY" class="payment-channel-item">
                <span style="font-size: 16px;">支付宝支付</span>
                <div style="font-size: 12px; color: #999; margin-top: 2px;">跳转到支付宝沙箱环境完成支付</div>
              </el-radio>
            </el-radio-group>

            <div class="payment-action-row">
              <el-button @click="payForBill" type="primary" class="pay-btn payment-action-btn" round :loading="paymentLoading">
                <i class="iconfont icon-r-yes payment-action-icon" v-if="!paymentLoading"></i>
                 {{paymentLoading ? '支付中...' : '立即支付'}}
              </el-button>
              <el-button @click="cancelForBill" type="danger" class="payment-action-btn cancel-btn" round>
                <i class="iconfont icon-r-left payment-action-icon"></i>
                 取消订单
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 退款确认对话框 -->
    <el-dialog
      title="退款确认"
      :visible.sync="refundDialogVisible"
      :width="isMobileLayout ? '92%' : '500px'"
      :top="isMobileLayout ? '6vh' : '15vh'"
      :custom-class="isMobileLayout ? 'refund-dialog refund-dialog-mobile' : 'refund-dialog'"
      :close-on-click-modal="false">
      <div class="refund-dialog-body">
        <el-alert
          title="退款提示"
          type="warning"
          description="退款将原路退回到您的支付账户，请确认是否继续？"
          show-icon
          :closable="false"
          style="margin-bottom: 20px;">
        </el-alert>

        <el-descriptions :column="1" border class="refund-summary">
          <el-descriptions-item label="订单编号">{{ billInfo.billId }}</el-descriptions-item>
          <el-descriptions-item label="影片名称">《{{ billInfo.sysSession.sysMovie.movieName }}》</el-descriptions-item>
          <el-descriptions-item label="放映时间">{{ billInfo.sysSession.sessionDate }} {{ billInfo.sysSession.playTime }}</el-descriptions-item>
          <el-descriptions-item label="座位信息">{{ billSeats.join(', ') }}</el-descriptions-item>
          <el-descriptions-item label="退款金额">
            <span class="refund-amount">
              ¥{{ (billInfo.sysSession.sessionPrice * billSeats.length).toFixed(2) }}
            </span>
          </el-descriptions-item>
        </el-descriptions>

        <div class="refund-form-wrapper">
          <el-form
            :model="refundForm"
            :rules="refundRules"
            ref="refundForm"
            :label-width="isMobileLayout ? 'auto' : '100px'"
            :label-position="isMobileLayout ? 'top' : 'right'"
            class="refund-form"
          >
            <el-form-item label="退款原因" prop="reason">
              <el-input
                v-model="refundForm.reason"
                type="textarea"
                :rows="3"
                placeholder="请输入退款原因（选填）"
                maxlength="200"
                show-word-limit>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer refund-dialog-footer">
        <el-button @click="refundDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmRefund" :loading="refundLoading">
          确认退款
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "BillDetail",
  data() {
    return {
      billId: this.$route.params.billId,
      billInfo: {
        payFailState: false,
        refundTime: null,
        sysSession: {
          sysMovie: {},
          sysHall: {
            sysCinema: {
              user: {}
            }
          }
        }
      },
      billSeats: [],
      payState: null,
      cancelState: null,
      cancelTime: null,
      //计时
      minutes: 1,
      seconds: 0,
      orderTimeoutMinutes: 2,
      // 支付相关
      paymentChannel: 'MOCK_WECHAT', // 默认模拟微信支付
      paymentLoading: false,
      // 退款相关
      refundState: false,
      refundDialogVisible: false,
      refundLoading: false,
      refundForm: {
        reason: ''
      },
      refundRules: {
        reason: [
          { min: 0, max: 200, message: '退款原因长度不能超过 200 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getBillInfo()
  },
  mounted() {
    this.add()
  },
  methods: {
    async getBillInfo() {
      const { data : res } = await axios.get('sysBill/' + this.billId)
      if(res.code !== 200) return this.$message.error('获取信息失败')
      let userId = JSON.parse(window.sessionStorage.getItem('loginUser')).userId
      if (userId !== res.data.userId) {
        this.$alert('非法操作！操作非本人订单。', '非法操作订单警告', {
          confirmButtonText: '我知道了',
          callback: action => {
            this.$router.push('/bill')
          }
        })
        return
      }
      this.billInfo = res.data

      // 获取超时配置
      this.orderTimeoutMinutes = await this.getOrderTimeout()

      this.cancelTime = this.billInfo.cancelTime
      console.log(this.billInfo)
      // 截止时间
      console.log(this.billInfo.deadline)
      //处理订单座位信息
      this.billSeats = JSON.parse(this.billInfo.seats)
      this.payState = this.billInfo.payState
      this.cancelState = this.billInfo.cancelState
      this.refundState = this.billInfo.refundState || false
      console.log('the create_time'+this.billInfo.createTime)
      this.computeLeftTime()
    },
    async payForBill() {
      this.paymentLoading = true
      
      try {
        // 计算总金额
        const totalAmount = (this.billInfo.sysSession.sessionPrice * this.billSeats.length).toFixed(2)
        const subject = `${this.billInfo.sysSession.sysMovie.movieName} - ${this.billInfo.sysSession.sessionDate} ${this.billInfo.sysSession.playTime}`
        const body = `${this.billSeats.join(', ')}`
        
        // 创建支付订单
        const paymentData = {
          orderId: this.billInfo.billId,
          channel: this.paymentChannel,
          totalAmount: parseFloat(totalAmount),
          subject: subject,
          body: body,
          returnUrl: window.location.origin + '/payment-result'
        }
        
        const { data: payRes } = await axios.post('/payment/create', paymentData)
        if (payRes.code !== 200) {
          this.$message.error('创建支付订单失败: ' + payRes.message)
          return
        }
        
        if (this.paymentChannel === 'MOCK_WECHAT') {
          const paymentData = payRes.msg || payRes.data
          this.showWechatPaymentDialog(paymentData)
        } else if (this.paymentChannel === 'MOCK_ALIPAY') {
          const paymentData = payRes.msg || payRes.data
          this.showAlipayMockPaymentDialog(paymentData)
        } else if (this.paymentChannel === 'ALIPAY') {
          const formHtml = payRes.msg || payRes.data
          this.handleAlipayPayment(formHtml)
        }
      } catch (error) {
        console.error('支付失败:', error)
        this.$message.error('支付失败: ' + error.message)
      } finally {
        this.paymentLoading = false
      }
    },
    
    async handleMockPayment(paymentResult, paymentSuccess = true) {
      // 模拟支付，根据传入的支付结果参数调用模拟支付接口
      console.log('模拟支付结果:', paymentResult, '类型:', typeof paymentResult, '支付成功:', paymentSuccess)
      
      let outTradeNo
      
      // 处理各种可能的数据格式
      if (typeof paymentResult === 'string') {
        if (paymentResult.includes(':')) {
          // 格式: "MOCK_PAYMENT_SUCCESS:MOCK_1234567890_96"
          outTradeNo = paymentResult.split(':')[1]
        } else {
          // 可能直接是outTradeNo
          outTradeNo = paymentResult
        }
      } else if (typeof paymentResult === 'object' && paymentResult) {
        // 对象格式: {outTradeNo: "xxx"} 或 {msg: "xxx"}
        outTradeNo = paymentResult.outTradeNo || paymentResult.msg
        if (outTradeNo && outTradeNo.includes(':')) {
          outTradeNo = outTradeNo.split(':')[1]
        }
      }
      
      if (!outTradeNo) {
        console.error('无法解析支付结果:', paymentResult)
        this.$message.error('支付结果格式错误，无法获取交易号')
        return
      }
      
      console.log('解析出的交易号:', outTradeNo)
      
      try {
        // 调用模拟支付API，传递支付结果参数
        const { data: mockRes } = await axios.post('/payment/mock/pay', null, {
          params: { 
            outTradeNo: outTradeNo,
            paymentSuccess: paymentSuccess
          }
        })
        
        if (mockRes.code === 200) {
          if (paymentSuccess) {
            // 支付成功
            this.billInfo.payState = true
            this.payState = true
            
            // 更新订单状态
            await this.updateBillStatus()
            
            this.$alert('支付成功！您可以前往个人中心查看订单信息', '支付通知', {
              confirmButtonText: '我知道了',
              callback: action => {
                this.$router.push('/bill')
              }
            })
            } else {
              // 支付失败，订单已关闭
              this.billInfo.payFailState = true
              this.billInfo.cancelState = true
              this.billInfo.cancelTime = new Date().toISOString()
              this.cancelState = true
              this.cancelTime = new Date().toISOString()
              
              this.$alert('支付失败，订单已自动关闭', '支付失败', {
                confirmButtonText: '我知道了',
                callback: action => {
                  this.$router.push('/bill')
                }
              })
            }
        } else {
          this.$message.error('模拟支付失败: ' + mockRes.message)
        }
      } catch (error) {
        this.$message.error('模拟支付处理失败: ' + error.message)
      }
    },

    showWechatPaymentDialog(paymentData) {
      this.$confirm('请选择下一步支付结果', '模拟微信支付', {
        confirmButtonText: '支付成功',
        cancelButtonText: '支付失败',
        type: 'info',
        center: true,
        customClass: 'wechat-payment-dialog'
      }).then(() => {
        this.handleMockPayment(paymentData, true)
      }).catch(() => {
        this.handleMockPayment(paymentData, false)
      })
    },

    showAlipayMockPaymentDialog(paymentData) {
      this.$confirm('请选择下一步支付结果', '模拟支付宝支付', {
        confirmButtonText: '支付成功',
        cancelButtonText: '支付失败',
        type: 'info',
        center: true,
        customClass: 'alipay-payment-dialog'
      }).then(() => {
        this.handleMockPayment(paymentData, true)
      }).catch(() => {
        this.handleMockPayment(paymentData, false)
      })
    },

    handleAlipayPayment(formHtml) {
      console.log('支付宝支付表单类型:', typeof formHtml)
      console.log('支付宝支付表单长度:', formHtml ? formHtml.length : 0)
      console.log('支付宝支付表单内容预览:', formHtml ? formHtml.substring(0, 200) + '...' : '无内容')
      
      if (!formHtml || formHtml.trim() === '') {
        this.$message.error('支付宝支付页面数据为空，请检查支付宝配置')
        console.error('支付宝表单为空，可能的原因:')
        console.error('1. 支付宝配置未完成 (APP ID, 私钥, 公钥)')
        console.error('2. 支付宝网关无法访问')
        console.error('3. 请求参数格式错误')
        return
      }
      
      if (!formHtml.includes('<form') && !formHtml.includes('<html')) {
        this.$message.error('支付宝返回数据格式错误: ' + formHtml)
        return
      }
      
      try {
        const newWindow = window.open('', '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes')
        if (!newWindow) {
          this.$message.error('无法打开支付窗口，请检查浏览器弹窗设置')
          return
        }
        
        newWindow.document.write(formHtml)
        newWindow.document.close()
        this.startPaymentPolling()
      } catch (error) {
        console.error('打开支付宝支付页面失败:', error)
        this.$message.error('打开支付页面失败: ' + error.message)
      }
    },

    startPaymentPolling() {
      let pollCount = 0
      const maxPolls = 40
      
      const pollInterval = setInterval(async () => {
        pollCount++
        
        try {
          const { data: billRes } = await axios.get(`sysBill/${this.billId}`)
          if (billRes.code === 200 && billRes.data.payState) {
            clearInterval(pollInterval)
            this.billInfo.payState = true
            this.payState = true
            
            this.$alert('支付成功！您可以前往个人中心查看订单信息', '支付通知', {
              confirmButtonText: '我知道了',
              callback: action => {
                this.$router.push('/bill')
              }
            })
            return
          }
        } catch (error) {
          console.error('查询支付状态失败:', error)
        }
        
        if (pollCount >= maxPolls) {
          clearInterval(pollInterval)
          this.$message.warning('支付状态查询超时，请手动刷新页面查看结果')
        }
      }, 3000)
    },
    
    async updateBillStatus() {
      // 更新订单状态和场次座位信息
      axios.defaults.headers.put['Content-Type'] = 'application/json'
      const { data: res } = await axios.put('sysBill', JSON.stringify(this.billInfo))
      if (res.code !== 200) {
        console.error('更新订单状态失败:', res.message)
      }
    },
    async cancelForBill() {
      //更新订单状态
      this.billInfo.cancelState = true
      this.billInfo.cancelTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      // 获取场次座位信息
      const { data : curSession } = await axios.get('sysSession/find/' + this.billInfo.sessionId)
      let sessionSeats = JSON.parse(curSession.data.sessionSeats)
      // 解析出订单选择的座位，更新座位信息
      for(let seat of this.billSeats){
        let row = seat.substring(0, seat.indexOf('排'))
        let col = Number.parseInt(seat.substring(seat.indexOf('排') + 1, seat.length - 1))
        sessionSeats[row][col - 1] = 0
      }
      // 更新订单信息和场次座位信息
      axios.defaults.headers.put['Content-Type'] = 'application/json'
      const { data: res } = await axios.put('sysBill/cancel',JSON.stringify({sysBill: this.billInfo, sessionSeats: JSON.stringify(sessionSeats)}))
      if(res.code !== 200) return this.$message.error('取消失败')

      this.payState = false
      this.cancelState = true
      this.cancelTime = this.billInfo.cancelTime
      this.$alert('取消成功！您可以前往个人中心查看订单信息', '取消通知', {
        confirmButtonText: '我知道了',
        callback: action => {
          this.$router.push('/billDetail/' + this.billInfo.billId)
        }
      })
    },
    computeLeftTime() {
      let cur = new Date()
      let deadline = new Date(this.billInfo.deadline)
      let diff = (deadline - cur) / 1000
      if (diff < 0) {
        this.minutes = 0
        this.seconds = 0
      } else {
        this.minutes = Math.floor(diff / 60)
        this.seconds = Math.floor(diff % 60)
      }
    },
    add: function () {
      let _this = this
      let time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59
          _this.minutes -= 1
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0
          window.clearInterval(time)
        } else {
          _this.seconds -= 1
        }
      }, 1000)
    },
    async getOrderTimeout() {
      try {
        const { data: res } = await axios.get('sysConfig/orderTimeout')
        return res.data || 2
      } catch (error) {
        console.error('获取订单超时配置失败:', error)
        return 2 // 默认2分钟
      }
    },
    //计时转换数字格式
    num: function (n) {
      return n < 10 ? '0' + n : '' + n
    },
    showRefundDialog() {
      this.refundForm.reason = ''
      this.refundDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.refundForm) {
          this.$refs.refundForm.clearValidate()
        }
      })
    },

    async confirmRefund() {
      // 表单验证（可选的退款原因）
      if (this.$refs.refundForm) {
        const valid = await this.$refs.refundForm.validate().catch(() => false)
        if (!valid) return
      }

      // 二次确认
      const confirmed = await this.$confirm(
        '确定要申请退款吗？退款将原路退回到您的支付账户。',
        '退款确认',
        {
          confirmButtonText: '确定退款',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(() => false)

      if (!confirmed) return

      this.refundLoading = true

      try {
        // 查询支付记录，获取商户订单号
        const { data: paymentRes } = await axios.get(`payment/query-by-order/${this.billInfo.billId}`)

        if (paymentRes.code !== 200 || !paymentRes.data) {
          this.$message.error('未找到支付记录，无法退款')
          return
        }

        const outTradeNo = paymentRes.data.outTradeNo
        const refundAmount = (this.billInfo.sysSession.sessionPrice * this.billSeats.length).toFixed(2)

        // 调用退款API（使用URL参数方式）
        const { data: res } = await axios.post('payment/refund', null, {
          params: {
            outTradeNo: outTradeNo,
            refundAmount: refundAmount,
            refundReason: this.refundForm.reason || '用户申请退款'
          }
        })

        if (res.code === 200) {
          this.$message.success('退款成功！退款将在1-3个工作日内到账')

          // 更新订单状态
          this.refundState = true
          this.billInfo.refundState = true
          this.billInfo.refundTime = new Date().toISOString()

          // 关闭对话框
          this.refundDialogVisible = false

          // 刷新订单信息
          await this.getBillInfo()
        } else {
          this.$message.error('退款失败: ' + (res.message || '请联系客服处理'))
        }
      } catch (error) {
        console.error('退款失败:', error)
        if (error.response && error.response.data && error.response.data.message) {
          this.$message.error('退款失败: ' + error.response.data.message)
        } else {
          this.$message.error('退款失败，请稍后重试或联系客服')
        }
      } finally {
        this.refundLoading = false
      }
    },

    formatDateTime(dateTime) {
      if (!dateTime) return ''
      return new Date(dateTime).toLocaleString('zh-CN')
    }
  },
  watch: {
    second: {
      handler (newVal) {
        this.num(newVal)
      }
    },
    minute: {
      handler (newVal) {
        this.num(newVal)
      }
    }
  },
  computed: {
    isMobileLayout() {
      return this.$platform.isMobile
    },
    second: function () {
      return this.num(this.seconds)
    },
    minute: function () {
      return this.num(this.minutes)
    }
  }
}
</script>

<style scoped>
.el-step {
  margin: 40px auto;
}

.bill-info-container{
  width: 80%;
  margin: 0 auto 40px auto;
}

.bill-info-status{
  height: 120px;
  background: #FFFBF2;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}

.pay-icon{
  width: 40px;
  height:40px;
  margin-left: 50px;
}

.pay-icon>img{
  width: 100%;
  height: 100%;
}

.pay-info{
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}

.pay-info-status{
  color: #FAAF00;
  font-size: 24px;
  font-weight: 700;
}

.pay-info-desc{
  color: #999;
  font-size: 13px;
}

.pay-info-desc>span{
  font-size: 16px;
  color: #faaf00;
  margin: 5px 5px;
}

.bill-info-status.finish{
  background: #F4FFF8;
}

.bill-info-status.invalid{
  background: #FFE0E0;
}

.pay-info-status.finish{
  color: #26CE61;
}

.pay-info-status.invalid{
  color: #faaaaa;
}

.bill-info-status.refund{
  background: #FFF8E1;
}

.pay-info-status.refund{
  color: #FF9800;
}

.bill-info-header{
  display: flex;
  justify-content: space-between;
}

.bill-info-helper{
  color: #999;
  font-size: 13px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 2px;
  margin-bottom: 8px;
}

.bill-info-phone{
  color: #f03d37;
  white-space: nowrap;
}

.bill-info-hours{
  white-space: nowrap;
}

.order-table{
  width: 100%;
  border: 1px solid #e5e5e5;
  border-spacing: 0;
  margin-bottom: 60px;
}

.order-table thead {
  background-color: #f7f7f7;
}

.order-table thead th {
  font-size: 16px;
  color: #333;
  width: 20%;
  padding: 14px 0;
  font-weight: 400;
}

.order-table td {
  text-align: center;
  padding: 20px 0;
  color: #333;
}

.order-table .movie-name {
  font-size: 16px;
}

.order-table .showtime {
  font-size: 14px;
  color: #f03d37;
}

.order-table .cinema-name {
  font-size: 14px;
}

.order-table .hall {
  display: inline-block;
  font-size: 14px;
  color: #424242;
  font-weight: 700;
  margin-right: 10px;
  vertical-align: top;
}

.order-table .seats {
  display: inline-flex;
  text-align: left;
  flex-wrap: wrap;
}

.order-table .seats span{
  margin-right: 5px;
}

.bill-info-area{
  display: flex;
  justify-content: space-between;
}

.bill-cinema-name{
  font-weight: 700;
}

.bill-cinema-info{
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.submit-bill{
  margin-top: 40px;
}

.submit-bill span{
  color: #f03d37;
  font-size: 32px;
  font-weight: 700;
}

.submit-bill span:before{
  content: '￥';
  font-size: 20px;
}

.mobile-order-card {
  display: grid;
  gap: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 40px;
}

.mobile-order-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-order-label {
  font-size: 13px;
  color: #6b7280;
}

.payment-channel-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}

.payment-channel-item {
  margin-right: 0;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
}

.pay-btn {
  font-size: 26px;
  margin-left: 0;
}

.payment-action-row {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.payment-action-btn {
  font-size: 26px;
  width: auto;
}

.payment-action-icon {
  font-size: 26px;
}

.refund-dialog-body {
  word-break: break-word;
}

.refund-summary {
  margin-top: 4px;
}

.refund-form-wrapper {
  margin-top: 20px;
}

.refund-amount {
  color: #f03d37;
  font-size: 18px;
  font-weight: bold;
}

.bill-detail-page.mobile .bill-info-container{
  width: 100%;
  padding: 0 16px 24px;
  margin: 0;
}

.bill-detail-page.mobile .bill-info-status{
  height: auto;
  padding: 16px;
  align-items: flex-start;
  margin-bottom: 24px;
}

.bill-detail-page.mobile .pay-icon{
  margin-left: 0;
}

.bill-detail-page.mobile .bill-info-header{
  display: block;
}

.bill-detail-page.mobile .bill-info-helper{
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
  line-height: 1.6;
}

.bill-detail-page.mobile .bill-info-area{
  flex-direction: column;
  gap: 20px;
}

.bill-detail-page.mobile .submit-bill{
  margin-top: 0;
}

.bill-detail-page.mobile .pay-btn,
.bill-detail-page.mobile .submit-bill .el-button{
  width: 100%;
  margin-left: 0;
}

.bill-detail-page.mobile .payment-action-row {
  flex-direction: row;
  gap: 10px;
}

.bill-detail-page.mobile .payment-action-btn {
  flex: 1 1 0;
  width: auto;
  margin: 0;
  font-size: 16px;
  padding: 12px 0;
}

.bill-detail-page.mobile .payment-action-icon {
  font-size: 18px;
}

.bill-detail-page.mobile .payment-channel-group {
  flex-direction: column;
}

.refund-dialog-mobile .refund-dialog-body {
  font-size: 14px;
}

.refund-dialog-mobile .refund-summary {
  margin-bottom: 8px;
}

.refund-dialog-mobile .refund-amount {
  font-size: 20px;
  line-height: 1.4;
}

.refund-dialog-mobile .refund-form-wrapper {
  margin-top: 16px;
}

.refund-dialog-mobile .refund-dialog-footer {
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
}

.refund-dialog-mobile .refund-dialog-footer .el-button {
  width: 100%;
  margin: 0;
}

.refund-dialog-mobile .refund-dialog-footer .el-button + .el-button {
  margin-left: 0;
}
</style>
